import { Download } from '@models/download.model';

export interface DownloadsStateModel {
    downloads: Download[] | null,
    loading: boolean;
    loaded: boolean;
    error: string | null
}

export const downloadsInitialState: DownloadsStateModel = {
    downloads: null,
    loading: false,
    loaded: false,
    error: null
}
